var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.13 43.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#ffffff;}.cls-1{stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.49,15.33C10.8,7.24,19.29,1,29.51,1,40.62,1,49.13,8.4,49.13,17.52c0,4-1.11,7.67-5.11,10.53h0a18.13,18.13,0,0,0,.6,8.36,1,1,0,0,1-1.3,1.22L32.51,33.81a21.44,21.44,0,0,1-3.13.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.68,33.81a22.69,22.69,0,0,0,6.49-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.18,14.06C7.55,14.06,1,19.8,1,26.88a9.52,9.52,0,0,0,4,8.17H5a11.73,11.73,0,0,1-.29,6A1,1,0,0,0,6,42.3l7.85-2.78a17.56,17.56,0,0,0,2.42.18c8.63,0,15.57-5.74,15.57-12.82S24.81,14.06,16.18,14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.72,39.52a17.64,17.64,0,0,1-5-1.81"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 9.49,
    cy: 27.33,
    r: 1.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16.67,
    cy: 27.33,
    r: 1.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.85,
    cy: 27.33,
    r: 1.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.86,
    cy: 16.83,
    r: 1.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 39.04,
    cy: 16.83,
    r: 1.83
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.0bf429068ca8974769bed56c8b884fc2.svg";
export { ForwardRef as ReactComponent };